import { render, staticRenderFns } from "./Contato.vue?vue&type=template&id=3e0c5c9c&scoped=true&"
import script from "./Contato.vue?vue&type=script&lang=js&"
export * from "./Contato.vue?vue&type=script&lang=js&"
import style0 from "./Contato.vue?vue&type=style&index=0&id=3e0c5c9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0c5c9c",
  null
  
)

export default component.exports